import { differenceInSeconds, secondsToMilliseconds } from 'date-fns'
import { useMemo } from 'react'
import { useGateway } from './api'

type UseIsGatewayOnline = {
  isOnline: boolean
  lastSeen: Date
}

export function useIsGatewayOnline(
  factoryId: string,
  gatewayId: string,
): UseIsGatewayOnline {
  const gatewayQuery = useGateway(
    factoryId,
    gatewayId,
    secondsToMilliseconds(45),
  )

  const isOnline = useMemo(() => {
    const lastHeartbeat = gatewayQuery.data?.lastPing
    if (lastHeartbeat) {
      return differenceInSeconds(new Date(), lastHeartbeat) < 60
    }
    return false
  }, [gatewayQuery.data?.lastPing])

  return {
    isOnline,
    lastSeen: gatewayQuery.data?.lastPing
      ? gatewayQuery.data.lastPing
      : new Date(),
  }
}
